<template>
  <div class="hibe-wrapper">
    <div class="hibe-des">
      <div class="decoration left top"></div>
      <div class="decoration right top"></div>
      <div class="decoration left bottom"></div>
      <div class="decoration right bottom"></div>
      <div class="large-icon"></div>
      <div class="content">
        <div class="title-bar">
          <div class="title">分层身份加密说明</div>
          <div class="fill"></div>
          <instruction-btn
            :id="instruction.excellent.hibe.id"
            :instruction-info="instruction.excellent.hibe.instructionInfo"
            tool-tip-placement="left"
          ></instruction-btn>
        </div>
        <div class="describe">
          分层身份加密是对属性加密的一种改进方案，它是一种由层级结构定义的属性加密。在传统的属性加密中，节点/用户之间没有层级结构关系，节点/用户的身份信息（属性）作为公钥，由密钥生成中心为每个节点/用户生成解密密钥并进行分配。HIBE 打破了传统的 IBE 方案，构造了一种层级结构关系，每一层节点/用户用来进行数据解密的解密密钥都由上一层级进行分配，也就是说，只有根节点/用户的密钥由 PKG 进行分配，这使得密钥的分配过程不再复杂，使得计算、权限分派变得简单，通信开销减少，适用于许多权限分级应用中。
        </div>

        <div class="instruction-des">
          使用方法：请先在区块链部署分层身份加密智能合约，生成密钥后即可使用该加解密工具。
        </div>
      </div>
    </div>
    <el-tabs v-model="activeName" :tab-position="tabPosition">
      <el-tab-pane label="初始化系统层级" name="init">
        <el-alert
          title="用户以公司组织为背景初始化一个多级系统"
          type="info"
          show-icon
          :closable="false"
        >
        </el-alert>
        <init v-if="activeName == 'init'" ref="init" @getPath="getPath"></init>
      </el-tab-pane>
      <el-tab-pane label="获取系统参数" name="getParams">
        <el-alert title="用户可以查看生成的系统参数" type="info" show-icon :closable="false">
        </el-alert>
        <getParams v-if="activeName == 'getParams'" ref="getParams"></getParams>
      </el-tab-pane>
      <el-tab-pane label="生成层级密钥" name="genPrvkey">
        <el-alert
          title="用户可以根据不同身份生成对应的层级密钥"
          type="info"
          show-icon
          :closable="false"
        >
        </el-alert>
        <genPrvkey v-if="activeName == 'genPrvkey'" ref="genPrvkey" @getPath="getPath"></genPrvkey>
      </el-tab-pane>
      <el-tab-pane label="系统参数上链" name="paramsOnchain">
        <el-alert title="用户可以将系统参数上链" type="info" show-icon :closable="false">
        </el-alert>
        <paramsOnchain v-if="activeName == 'paramsOnchain'" ref="paramsOnchain"></paramsOnchain>
      </el-tab-pane>

      <el-tab-pane label="系统参数链上查询" name="paramsQuery">
        <el-alert title="用户可以查询已经上链的系统参数" type="info" show-icon :closable="false">
        </el-alert>
        <paramsQuery v-if="activeName == 'paramsQuery'" ref="paramsQuery"></paramsQuery>
      </el-tab-pane>

      <el-tab-pane label="加密数据上链" name="cipherDataOnchain">
        <el-alert title="用户可以将明文信息加密后上链" type="info" show-icon :closable="false">
        </el-alert>
        <cipherDataOnchain
          v-if="activeName == 'cipherDataOnchain'"
          ref="cipherDataOnchain"
        ></cipherDataOnchain>
      </el-tab-pane>

      <el-tab-pane label="加密数据链上查询" name="cipherDataQuery">
        <el-alert
          title="用户可以使用符合解密条件的用户密钥查询已上链的明文信息"
          type="info"
          show-icon
          :closable="false"
        >
        </el-alert>
        <cipherDataQuery
          v-if="activeName == 'cipherDataQuery'"
          ref="cipherDataQuery"
        ></cipherDataQuery>
      </el-tab-pane>
    </el-tabs>

    <contractDetail ref="contractDetail"></contractDetail>
  </div>
</template>
<script>
import instruction from '@/instruction/index'
import contractDetail from './contractDetail'
import init from './init'
import getParams from './getParams'
import genPrvkey from './genPrvkey'
import paramsOnchain from './paramsOnchain'
import paramsQuery from './paramsQuery'
import cipherDataOnchain from './cipherDataOnchain'
import cipherDataQuery from './cipherDataQuery'

export default {
  name: 'Index',
  components: {
    contractDetail,
    init,
    getParams,
    genPrvkey,
    paramsOnchain,
    paramsQuery,
    cipherDataOnchain,
    cipherDataQuery
  },
  data() {
    return {
      activeName: 'init',
      tabPosition: 'top',
      keyspath: '',
      paramspath: '',
      path: '',
      kpath: '',
      collapseText: 'describe',
      keyArr: [],
      instruction
    }
  },

  mounted() {
    this.getPath()
    // this.getContractDetact()
  },
  methods: {
    getContractDetact() {
      let params = {
        chainid: this.$route.query.chainId
      }
      this.$apis.hibe.hibeContractDetact(params).then(res => {
        if (res.errors[0].code == 40011) {
          this.$refs.contractDetail.handleOpen(res.data)
        }
      })
    },

    refresh() {
      this.getContractDetact()
    },
    getPath() {
      this.keyspath = localStorage.getItem('keyspath')
      this.paramspath = localStorage.getItem('paramspath')
      this.path = localStorage.getItem('path')
      this.kpath = localStorage.getItem('kpath')
      this.keyArr = JSON.parse(localStorage.getItem('keyArr'))
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.hibe-wrapper {
  @include adaptation(
    (
      --common-gap-4: 4px,
      --common-gap-8: 8px,
      --common-gap-12: 12px,
      --common-gap-16: 16px,
      --common-gap-32: 32px,
      --common-gap-56: 56px,
      --common-pos-neg-offset: -1.5px,
      --decoration-border-width: 3px,
      --decoration-width: 32px,
      --decoration-height: 28px,
      --large-icon-width: 137px,
      --large-icon-height: 137px,
      --title-bar-height: 26px,
      --title-hint-line-height: 20px
    )
  );
  .hibe-des {
    color: var(--base-color-text-primary);
    background-color: var(--base-background-color-light);
    border: var(--base-border-width) solid var(--base-border-color-light);
    padding: var(--common-gap-16) var(--common-gap-56) var(--common-gap-16) var(--common-gap-32);
    position: relative;
    display: flex;
    align-items: center;

    .decoration {
      border: var(--decoration-border-width) solid transparent;
      position: absolute;
      width: var(--decoration-width);
      height: var(--decoration-height);
      &.left {
        left: var(--common-pos-neg-offset);
        border-left-color: var(--base-color-notice);
      }

      &.top {
        top: var(--common-pos-neg-offset);
        border-top-color: var(--base-color-notice);
      }

      &.right {
        right: var(--common-pos-neg-offset);
        border-right-color: var(--base-color-notice);
      }

      &.bottom {
        bottom: var(--common-pos-neg-offset);
        border-bottom-color: var(--base-color-notice);
      }
    }

    .large-icon {
      background-image: url('~@/assets/images/excellent/hibe-large-icon.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      min-width: var(--large-icon-width);
      margin-right: var(--common-gap-32);
      height: var(--large-icon-height);
    }

    .content {
      align-self: flex-start;
      margin-top: var(--common-gap-8);
      display: flex;
      flex-direction: column;
      height: calc(var(--large-icon-height) - var(--common-gap-8));

      .title-bar {
        display: flex;
        align-items: center;
        height: var(--title-bar-height);
        line-height: var(--title-bar-height);
        margin-bottom: var(--common-gap-16);

        .title {
          margin-right: var(--common-gap-16);
          font-weight: 700;
          font-size: var(--base-font-size-extra-large);
        }

        .fill {
          flex-grow: 1;
        }

        .hint {
          color: var(--base-color-notice-light-2);
          align-self: flex-end;
          line-height: var(--title-hint-line-height);
        }
      }

      .describe {
        color: var(--base-color-text-regular);
        flex-grow: 1;
      }

      .instruction-des {
        display: flex;
        align-items: center;
        &::before {
          content: '';
          width: var(--common-gap-4);
          height: var(--common-gap-4);
          margin-right: var(--common-gap-4);
          border-radius: 50%;
          background-color: var(--base-color-notice-light-2);
        }
      }
    }
  }

  .el-alert {
    margin-bottom: var(--common-gap-16);
  }
}
</style>
